<template>
    <div v-if="visible" id="pm-welcome-dialog" style="z-index: 4;">
        <div id="pm-welcome-dialog-content" style="font-size: 15px; display: flex; align-items: center; justify-content: center; padding: 0px;">
            <div style="position: relative; width: 100%; height: 100%; padding-top: 20px;">


                <div @click="close" style="position: absolute; width: 28px; height: 28px; line-height: 22px; text-align: center; top: 22px; right: 12px; border: 2px solid #ddd; border-radius: 50%;" class="main-dialog--close">
                    <span style="font-weight: 600;"><v-icon style="font-size: 16px;">close</v-icon></span>
                </div>

                <div v-if="trialExtended === 0" style="padding: 0 40px;">
                    <img src="https://cdn.denticalc.com/images/gift-card.jpg" style="max-width: 90%;" />

                    <h2 style="margin-top: -20px; font-size: 16px; font-weight: 600; text-transform: uppercase;">{{ $t('iap.redeem-promo-code')}}</h2>
                    <br/>

                    <v-text-field type="email" ref="reviewEmail" box id="feedback-email-input" v-model="promoCode" :placeholder="$t('iap.promo_code')" />
                    <!-- <pm-promo-code-input v-model="email" :placeholder="$t('iap.promo_code')" /> -->


                    <v-btn style="border-radius: 16px;" large class="primary" :loading="processing" @click="send">
                        <span style="text-transform: uppercase!important;">
                            SUBMIT <v-icon style="margin-top: -2px;">chevron_right</v-icon>
                        </span>
                    </v-btn>
                </div>
                <div v-if="trialExtended > 0">
                    <img src="https://cdn.denticalc.com/images/gift-card.jpg" style="max-width: 90%;" />
                    <br/>
                    <span style="font-size: 40px; font-weight: 600; color: green;">+ {{ trialExtended }} days</span>
                    <h2 style="margin-top: 20px; font-size: 16px; font-weight: 600; text-transform: uppercase;">Your trial has been<br/>successfully extended</h2>
                    <br/><br/>
                    <v-btn style="border-radius: 16px;" large class="grey lighten-3" @click="close">
                        <span style="text-transform: uppercase!important;">
                            CLOSE <v-icon style="margin-top: -2px;">chevron_right</v-icon>
                        </span>
                    </v-btn>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import { getUserDataAsString } from "../../utils/user/user-data";
import PmPromoCodeInput from "./promo-code-input.vue"
import { getPromoCode, usePromoCode } from "../../utils/firebase/firestore-promo-codes";

export default {
    components: {
        PmPromoCodeInput
    },

    data: () => ({
        visible: false,
        step: 0,
        promoCode: '',
        processing: false,
        trialExtended: 0,

    }),

    created() {
        this.$bus.$on('promo-code-form:show', () => {
            this.visible = true;
        });
    },

    methods: {
        close() {
            this.visible = false;
        },

        validate(data) {
            if (typeof data.used !== "undefined") {
                this.$bus.$emit("app.showSnackbar", {text: "This code has been already used", color: "red", timeout: 5000});
                return false;
            }
            return true;
        },

        async send() {
            if (this.promoCode.trim() === "") {
                return;
            }

            this.processing = true;
            const result = await getPromoCode(this.promoCode);
            this.processing = false;

            if (result === null) {
                this.$bus.$emit("app.showSnackbar", {text: "Invalid code", color: "red"});
                return false;
            }

            if (!this.validate(result)) return;

            usePromoCode(this.promoCode);

            this.extendTrial(result);
            this.$bus.$emit("flutter:updateFirstRunTS");
        },

        extendTrial(result) {
            const date = new Date();
            date.setDate(date.getDate() + result.duration);
            this.trialExtended = result.duration;

            if (typeof result.sku === "string") {
                localStorage.setItem('ca_' + result.sku, String(date.getTime()))
            } else {
                localStorage.setItem('extendedTrial', String(date.getTime()));
            }
        },
    }
};
</script>
